import AbstractDataAdapter from '../AbstractDataAdapter';

class EquipmentGroupDataAdapter extends AbstractDataAdapter {
  /**
   *
   * @returns {string[]}
   */
  static get allowedFields() {
    return ['name', 'projectCategoryId'];
  }

  /**
   *
   * @returns {string[]}
   */
  static get requiredFields() {
    return ['name', 'projectCategoryId'];
  }
}

export default EquipmentGroupDataAdapter;
